/**
 * Shop upsell / booking-success config.
 * - Empty `shopUrl` → hide sidebar Shop + modal shop CTA (success modal still shows).
 * - Set `shopUrl` → enable sidebar Shop + "Continue to Shop" on success modal.
 */
export const SHOP_CONFIG = {
  // Empty string disables Shop CTA + sidebar only (success modal still shows)
  shopUrl: "https://gemsevents.carnivaltribe.com/",
  upsell: {
    title: "Package booked",
    subtitle: "Your costume package has been reserved.",
    note: "You have 5 days to complete payment and finalize your order.",
    pitchTitle: "Complete your carnival experience",
    pitchBody:
      "Pick up extra merch, tickets, and add-ons from the shop while you're here.",
    primaryCta: "Continue to Shop",
    secondaryCta: "Stay on Orders",
    dismissCta: "Continue",
  },
} as const;

export const SHOP_UPSELL_SESSION_KEY = "gem.shopUpsellPending";
